<script setup lang="ts">
import {onMounted, ref} from 'vue';
import {useCookie} from '#imports';

const showBanner = ref(true);
const COOKIE_NAME = 'banner_novo_portal';
const cookieBanner = useCookie<boolean | null>(COOKIE_NAME, {
    default: () => null,
    maxAge: 60 * 60 * 24 * 365,
    path: '/',
});

function closeBanner() {
    cookieBanner.value = true;
    showBanner.value = false;
    document.body.style.overflow = 'auto';
}

onMounted(() => {
    if (cookieBanner.value) {
        showBanner.value = false;
    } else {
        document.body.style.overflow = 'hidden';
    }
});
</script>

<template>
    <div
        v-if="showBanner"
        class="
            fixed
            inset-0
            z-50
            flex
            items-center
            justify-center
            bg-gray-500/80
        "
    >
        <div
            class="
                relative
                bg-white
                p-0
                rounded-md
                shadow-lg
            "
        >
            <button
                class="
                    absolute
                    top-4
                    right-4
                    text-red-600
                    text-3xl
                    font-bold
                    cursor-pointer
                "
                @click="closeBanner"
                aria-label="Fechar Banner"
            >
                &times;
            </button>

            <NuxtLink to="/noticias/evolucao-digital" prefetch @click="closeBanner">
                <picture>
                    <source
                        media="(max-width: 640px)"
                        srcset="/assets/images/2025_BANNER_POP-UP_SITE_350x500px.png"
                    />
                    <img
                        src="/assets/images/2025_BANNER_POP-UP_SITE_900x600px.png"
                        alt="Banner Novo Portal"
                        class="block max-w-full h-auto"
                    />
                </picture>
            </NuxtLink>
        </div>
    </div>
</template>
